"use client";

import { AgentIndustryFilter } from "@/app/(saas)/(app)/business-brokers/_components/filters/agent-industry-filter";
import {
  EditDialog,
  EditDialogContent,
  EditDialogHeader,
  EditDialogTitle,
  EditDialogTrigger,
} from "@/components/common/edit-dialog";
import { useTranslations } from "next-intl";
import type { PropsWithChildren } from "react";

export function AgentIndustryMobileFilter({ children }: PropsWithChildren) {
  const t = useTranslations();

  return (
    <EditDialog>
      <EditDialogTrigger asChild>{children}</EditDialogTrigger>

      <EditDialogContent noFooter wrapperClassName="overflow-hidden">
        <EditDialogHeader>
          <EditDialogTitle>
            {t("saas.agentSearch.filters.specialty")}
          </EditDialogTitle>
        </EditDialogHeader>

        <div className="py-4 pb-8 h-full flex flex-col">
          <AgentIndustryFilter />
        </div>
      </EditDialogContent>
    </EditDialog>
  );
}
